module.exports = __webpack_public_path__ + "img/title-01.711041a9.png";